"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = void 0;
var connected_react_router_1 = require("connected-react-router");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var CartActions = require("@caddigital/sok-reducers/lib/actions/cart");
var ProjectActions = require("@caddigital/sok-reducers/lib/actions/projects");
var ToastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var download_1 = require("utils/download");
var mapDispatchToProps = function (dispatch) { return ({
    downloadFolder: function (token) { return function (item) {
        var retVal = dispatch(ToastActions.addNewToast((0, translation_1.getLocalization)('files/toast/download/loading-title'), (0, translation_1.getLocalization)('files/toast/download/loading-text'), 'NORMAL', [], undefined, 0));
        var uuid = retVal.payload.uuid;
        (0, download_1.downloadFiles)(token, [item], undefined, undefined, function () { return dispatch(ToastActions.removeToast(uuid)); }, { includeSelf: 'false', includeSubFolders: 'true' });
    }; },
    convert: function (file) {
        return dispatch(FilesActions.generatePreviewRequest(file.uuid));
    },
    setSearchString: function (val) {
        return dispatch(FilesActions.setSearchStringAction(val));
    },
    setSearchType: function (type) {
        return dispatch(FilesActions.setSearchFileTypeAction(type));
    },
    setPagingOptions: function (props) { return function (offset, itemsPerPage) {
        return dispatch(FilesActions.setPagingOptions({
            sortBy: props.sortByOptions.sortBy,
            order: props.sortByOptions.order,
            filters: props.sortByOptions.filters,
            offset: offset,
            limit: itemsPerPage
        }));
    }; },
    setSortOptions: function (props) { return function (sortBy, order) {
        return dispatch(FilesActions.setPagingOptions({
            sortBy: sortBy,
            order: order,
            filters: props.sortByOptions.filters,
            offset: props.sortByOptions.offset,
            limit: props.sortByOptions.limit
        }));
    }; },
    setFilterOptions: function (props) { return function (column, value) {
        var f = __assign({}, props.sortByOptions.filters);
        f[column] = value;
        dispatch(FilesActions.setPagingOptions({
            sortBy: props.sortByOptions.sortBy,
            order: props.sortByOptions.order,
            offset: props.sortByOptions.offset,
            limit: props.sortByOptions.limit,
            filters: f
        }));
    }; },
    onFetchProjects: function () {
        return dispatch(ProjectActions.fetchProjects({
            limit: 6,
            order: 'DESC',
            orderBy: 'visitedAt'
        }));
    },
    onLimitToFolder: function (folderId) {
        return dispatch(FilesActions.limitSearchFolderId(folderId));
    },
    onFetchFiles: function (fileId, sortByOptions, searchOptions) {
        dispatch(FilesActions.fetchFiles(fileId, sortByOptions, searchOptions));
    },
    toggleAdvancedSearchDropdown: function () {
        return dispatch(FilesActions.toggleAdvancedSearchDropdownAction());
    },
    toggleSearchDropdown: function () {
        return dispatch(FilesActions.toggleSearchDropdownAction());
    },
    toggleShowBookmarks: function () { return dispatch(FilesActions.toggleShowBookmarks()); },
    toggleShowBookmarksOff: function () { return dispatch(FilesActions.toggleShowBookmarksOff()); },
    toggleEmptyFolders: function (props) { return function (value) {
        dispatch(FilesActions.setHideEmptyFolders(value));
    }; },
    toggleFilter: function (props) { return function (filter) {
        var nameMeta = props.metaDataColumns.find(function (c) { return c.name === 'name-meta'; });
        var sortBy = filter === 'RECENTS' ? 'added-meta' : nameMeta ? nameMeta.id : null;
        dispatch(FilesActions.setPagingOptions({
            sortBy: sortBy,
            order: 'asc',
            filters: props.sortByOptions.filters,
            offset: props.sortByOptions.offset,
            limit: props.sortByOptions.limit
        }));
        dispatch(FilesActions.setFilteringType(filter));
    }; },
    toggleSortDropdown: function () { return dispatch(FilesActions.toggleSortDropdownAction()); },
    toggleFiltersDropdown: function () {
        return dispatch(FilesActions.toggleFiltersDropdownAction());
    },
    toggleColumnsDropdown: function () {
        return dispatch(FilesActions.toggleColumnsDropdownAction());
    },
    toggleMobileSearchOverlay: function () {
        return dispatch(FilesActions.toggleMobileSearchOverlayAction());
    },
    onAddCartItems: function (items, rootId) { return dispatch(CartActions.addItems(items, rootId)); },
    onSelectFileItems: function (items) {
        return dispatch(FilesActions.selectFileItems(items));
    },
    onUnselectFileItems: function (items) {
        return dispatch(FilesActions.unselectFileItems(items));
    },
    quickSearchFiles: function (fileId, sortByOptions, searchOptions) {
        return dispatch(FilesActions.quickSearchFilesRequest(fileId, sortByOptions, searchOptions, undefined, 'QUICK_SEARCH'));
    },
    toggleSelectionCart: function () { return dispatch(CartActions.toggleCart()); },
    onBookmarkClick: function (fileIds) {
        dispatch(FilesActions.bookmarkFile(fileIds));
    },
    onUnBookmarkClick: function (fileIds) {
        return dispatch(FilesActions.unbookmarkFile(fileIds));
    },
    onResetSortOptions: function () { return dispatch(FilesActions.resetSortOptionsAction()); },
    selectCustomMeta: function (customMeta, value, projectId) {
        dispatch(FilesActions.toggleAllMetadataColumns(customMeta, value, projectId));
    },
    toggleAllMetadataColumns: function (metas, value, projectId) {
        dispatch(FilesActions.toggleAllMetadataColumns(metas, value, projectId));
    },
    clearAllColumnFilters: function () {
        return dispatch(FilesActions.clearAllColumnFiltersAction());
    },
    clearState: function () { return dispatch(FilesActions.resetSearchOptionsAction()); },
    fetchProjectFileListColumns: function (projectId) {
        return dispatch(FilesActions.fetchFileListColumns(projectId));
    },
    setContentSearch: function (val) {
        return dispatch(FilesActions.setContainsTermStringAction(val));
    },
    clearSortByOptions: function () { return dispatch(FilesActions.clearSortByOptions()); },
    navigateTo: function (url) {
        dispatch((0, connected_react_router_1.push)(url));
    },
    moveToFolder: function (baseUrl, folderId, filtering) {
        var url = baseUrl.replace(/\/[^\/]*$/, '/' + folderId);
        dispatch((0, connected_react_router_1.push)(url));
    },
    toggleRecents: function () { return dispatch(FilesActions.toggleRecents()); },
    openNotificationsMenu: function (files, parent) { return dispatch(FilesActions.openNotificationsOptionsPaneAction(files, parent)); },
    toggleMoreSearch: function (props) { return function (status) {
        dispatch(FilesActions.toggleMoreSearch(status));
    }; },
    closeDialog: function () {
        dispatch(FilesActions.PropertiesActions.closeOverlay());
    },
    createNewFolder: function (name, description, parentId) {
        return function (e) {
            e.preventDefault();
            dispatch(FilesActions.PropertiesActions.saveNewFolderRequest(name, parentId, 'Folder', description));
        };
    },
    getContent: function (parent) {
        dispatch(FilesActions.FileBrowserActions.fetchTree(parent, ['FOLDER'], 'MINIMAL', undefined, true));
    },
    selectItem: function (folder) {
        dispatch(FilesActions.FileBrowserActions.copySelectTargetAction(folder));
    },
    changeExpand: function (expand, folder) {
        return dispatch(FilesActions.FileBrowserActions.copyChangeExpand(expand, folder));
    },
    saveFilelistWidth: function (project, width, status) {
        dispatch(dispatch(FilesActions.setFilelistWidth(width, status)));
        dispatch(FilesActions.saveFilelistWidthRequestAction(project, width, status));
    },
    setFilelistWidth: function (x) {
        dispatch(FilesActions.setFilelistWidth(x, x >= 5 ? 'OPEN' : 'CLOSED'));
    },
    collapseAll: function () { return dispatch(FilesActions.collapseAll()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
